import { getHost } from "@src/env";
import type { Links } from "@src/types";
import { useMutation } from "@tanstack/react-query";

import { parseJSON } from "@src/utils/json";
import { safeFetch } from "@src/utils/safeFetch";

export function useLinksMutation(idRadioOrCnpj: string) {
  return useMutation<Links, Error>({
    mutationKey: ["links", idRadioOrCnpj],
    mutationFn: async () => {
      if (!idRadioOrCnpj) {
        return;
      }
      const host = getHost();
      const response = await safeFetch(
        "useLinksMutation",
        `${host}/api/links/${idRadioOrCnpj}`,
      );
      const data = await parseJSON("useLinksMutation", response);
      if (!response.ok) {
        const messages: Record<string, string> = {
          data_not_found: `Nenhum link foi encontrado com o nome/CNPJ ${idRadioOrCnpj}`,
        };
        const message = messages[data.error] ?? "Erro desconhecido";
        throw new Error(message);
      }
      if (data.found_by === "cnpj" && data.links.length === 0) {
        throw new Error("O CNPJ foi localizado, mas não há rádios vinculadas.");
      }
      return data;
    },
    onError: console.log,
  });
}
